// extracted by mini-css-extract-plugin
export default {"iconRequest":"menuNavigation_iconRequest__Cq23l"};